var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "tabsBar", staticClass: "tabs-bar" }, [
    _c("div", { staticClass: "actions" }, [
      _c(
        "span",
        { class: { disabled: _vm.isFirst }, on: { click: _vm.handlePrev } },
        [_c("i", { staticClass: "el-icon-back" })]
      ),
      _c(
        "span",
        { class: { disabled: _vm.isLast }, on: { click: _vm.handleNext } },
        [_c("i", { staticClass: "el-icon-right" })]
      ),
      _c("span", { on: { click: _vm.onRefresh } }, [
        _c("i", { staticClass: "el-icon-refresh-right" }),
      ]),
    ]),
    _c(
      "ul",
      { ref: "tabs", staticClass: "tabs", style: _vm.tabsStyle },
      _vm._l(_vm.histories, function (history, idx) {
        return _c(
          "li",
          {
            key: idx,
            staticClass: "tab",
            class: { "is-act": _vm.route.path === history.path },
            on: {
              click: function ($event) {
                return _vm.handlePush(history)
              },
            },
          },
          [
            _c("span", {
              staticClass: "name",
              domProps: {
                textContent: _vm._s(
                  `${_vm.parseTitle(history.title)}${
                    history.subTitle ? ` - ${history.subTitle}` : ""
                  }`
                ),
              },
            }),
            _vm.histories.length > 1
              ? _c(
                  "span",
                  {
                    staticClass: "remove",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleClose(idx, history)
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-close" })]
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
    _vm.showDropdown
      ? _c(
          "div",
          { staticClass: "tab-more" },
          [
            _c("i", { staticClass: "el-icon-more" }),
            _c(
              "el-select",
              {
                attrs: { value: _vm.currentIndex },
                on: { change: _vm.onSelectChange },
              },
              _vm._l(_vm.histories, function (history, i) {
                return _c("el-option", {
                  key: i,
                  attrs: {
                    label: `${_vm.parseTitle(history.title)}${
                      history.subTitle ? ` - ${history.subTitle}` : ""
                    }`,
                    value: i,
                  },
                })
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }